import styled from 'styled-components'

type IframeWrapperProps = {
  $fullBleed?: boolean
  $height?: number | null
  $viewportScroll?: boolean
}

export const IframeWrapper = styled.div<IframeWrapperProps>`
  position: ${({ $viewportScroll }) => $viewportScroll ? 'sticky' : 'relative'};
  top: ${({ $viewportScroll }) => $viewportScroll ? '64px' : 'auto'};
  align-self: ${({ $viewportScroll }) => $viewportScroll ? 'flex-start' : 'auto'};
  z-index: ${({ $viewportScroll }) => $viewportScroll ? 1 : 'auto'};
  flex: 1 1 auto;
  display: flex;
  width: ${({ $fullBleed }) => $fullBleed ? 'calc(100% + 40px)' : '100%'};
  max-width: ${({ $fullBleed }) => $fullBleed ? 'calc(100% + 40px)' : '100%'};
  min-width: 0;
  margin: ${({ $fullBleed }) => $fullBleed ? '-10px -20px 0' : '0'};
  min-height: calc(100vh - 110px);
  height: ${({ $height }) => $height ? `${$height}px` : 'calc(100vh - 110px)'};
  max-height: ${({ $height }) => $height ? `${$height}px` : 'calc(100vh - 110px)'};
  overflow: clip;

  @supports (height: 100dvh) {
    min-height: calc(100dvh - 110px);
    height: ${({ $height }) => $height ? `${$height}px` : 'calc(100dvh - 110px)'};
    max-height: ${({ $height }) => $height ? `${$height}px` : 'calc(100dvh - 110px)'};
  }

  @media (max-width: 768px) {
    width: ${({ $fullBleed }) => $fullBleed ? 'calc(100% + 20px)' : '100%'};
    margin: ${({ $fullBleed }) => $fullBleed ? '0 -10px' : '0'};
    min-height: calc(100vh - 64px);
    height: ${({ $height }) => $height ? `${$height}px` : 'calc(100vh - 64px)'};
    max-height: ${({ $height }) => $height ? `${$height}px` : 'calc(100vh - 64px)'};

    @supports (height: 100dvh) {
      min-height: calc(100dvh - 64px);
      height: ${({ $height }) => $height ? `${$height}px` : 'calc(100dvh - 64px)'};
      max-height: ${({ $height }) => $height ? `${$height}px` : 'calc(100dvh - 64px)'};
    }
  }
`

export const IframeElement = styled.iframe`
  flex: 1 1 auto;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  height: 100%;
  display: block;
  border: 0;
`

export const IframeControls = styled.div`
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 20;
  display: flex;
  gap: 8px;
  opacity: 0.42;
  transition: opacity 0.2s ease, transform 0.2s ease;

  &:hover,
  &:focus-within {
    opacity: 1;
    transform: translateY(-1px);
  }

  .ant-btn {
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.18);
  }

  @media (max-width: 768px) {
    right: 14px;
    bottom: 14px;
  }
`

export const IframeLoader = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
  z-index: 1;
`
